<script>
import {computed} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import useSharedData from "@/use/SharedData";

export default {
    props: {
        paySlip: {
            type: Object,
            required: true,
            default: () => {
                return {
                    details: [],
                };
            },
        },
    },
    setup(props) {
        const {backgroundColor} = useSharedData();
        const {priceFormat} = useSharedMethod();

        const details = computed(() => {
            return props.paySlip.details.sort((a, b) => {
                // First, compare by the "order" field
                if (a.ordre !== b.ordre) {
                    return a.ordre - b.ordre;
                }
                // If the "order" fields are equal, compare by the "code" field
                return a.code.localeCompare(b.code);
            });
        });

        return {
            priceFormat,
            details,
            backgroundColor,
        }
    }
};
</script>

<template>
    <v-tabs
        class="tabs"
        color="teal"
        :background-color="backgroundColor"
        vertical
        slider-size="7"
    >
        <v-tab>
            <v-icon left>mdi-bookshelf</v-icon>
            {{ $t('pay_slip.pay_sections') }}
        </v-tab>
        <v-tab>
            <v-icon left>mdi-variable</v-icon>
            {{ $t('pay_slip.params') }}
        </v-tab>
        <v-tab>
            <v-icon left>mdi-sigma</v-icon>
            {{ $t('pay_slip.totals') }}
        </v-tab>
        <v-tab-item>
            <v-simple-table
                dense
                fixed-header
                height="370"
                style="border-collapse: collapse; border: 1px solid black;"
            >
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">{{ $t('common.code') }}</th>
                        <th class="text-left">{{ $t('common.label') }}</th>
                        <th class="text-left">{{ $t('common.amount') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(detail, index) in details"
                        :key="index"
                        v-show="detail.value !== 0 && detail.value !== null"
                    >
                        <td>
                            <w-tooltip
                                :label="detail.code"
                                :tooltip="detail.formule"
                            />
                        </td>
                        <td>
                            {{ detail.label }}
                        </td>
                        <td>
                            {{ priceFormat(detail.value) }}
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-tab-item>
        <v-tab-item>
            <v-simple-table
                dense
                fixed-header
                height="370"
                style="border-collapse: collapse; border: 1px solid black;"
            >
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">{{ $t('common.name') }}</th>
                        <th class="text-left">{{ $t('common.designation') }}</th>
                        <th class="text-left">{{ $t('common.value') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(parameter, index) in paySlip.parameters.slice().sort((a, b) => a.name.localeCompare(b.name))"
                        :key="index"
                    >
                        <td>
                            {{ parameter.name }}
                        </td>
                        <td>
                            {{ $t(`pay_slip.${parameter.name}`) }}
                        </td>
                        <td>
                            {{ parameter.value }}
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-tab-item>
        <v-tab-item>
            <v-simple-table
                dense
                fixed-header
                height="370"
                style="border-collapse: collapse; border: 1px solid black;"
            >
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">{{ $t('common.name') }}</th>
                        <th class="text-left">{{ $t('common.designation') }}</th>
                        <th class="text-left">{{ $t('common.value') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(total, index) in paySlip.totals.slice().sort((a, b) => a.name.localeCompare(b.name))"
                        :key="index"
                    >
                        <td>
                            {{ total.name }}
                        </td>
                        <td>
                            {{ $t(`pay_slip.${total.name}`) }}
                        </td>
                        <td>
                            {{ total.value }}
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-tab-item>
    </v-tabs>
</template>

<style scoped>
div.tabs [role="tab"] {
    justify-content: flex-start;
}
</style>